import React, { useEffect, useState } from "react";
import { urlFor, client } from "../../client";
import MotionWrap from "../../wrapper/MotionWrap";

import "./About.scss";

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type=="abouts"]';

    client.fetch(query).then((data) => setAbouts(data));
  }, []);

  const { title, description, imgUrl } = abouts[0] || {};
  
  return (
    <div id="about">
      <div className="left-section">
        <h1>
          CIAO,
          SOMOS
          <br />
          <span>{title}</span>!
        </h1>
        <p>{description}</p>
      </div>
      <img src={imgUrl ? urlFor(imgUrl).url() : ""} alt={title} />
    </div>
  );
};

export default MotionWrap(About, 'app__about');